<template>
  <div>
    <v-btn
      :disabled="!enablePlayButton"
      large
      color="red darken-3"
      @click="$emit('onStart')"
      fab>
      <v-icon>play_arrow</v-icon>
    </v-btn>
    <v-btn
      :disabled="!enableStopButton"
      large
      color="blue darken-3"
      @click="$emit('onStop')"
      fab>
      <v-icon>stop</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "StreamingControls",
  props: {
    enablePlayButton: {
      type: Boolean
    },
    enableStopButton: {
      type: Boolean
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/live/StreamingControls.vue